import {useEffect, useState} from "react";
import {Typography, TextField, Button, Stack, Divider} from "@mui/material";
import {
    useSystemAlertActions,
    useSystemAlertState,
} from "@/store/systemAlertSlice";
import {
    Actions,
    Description,
    FormPaper,
    PageWrapper,
} from "./SystemAlertPage.elements";
import { useLoadingActions } from "@/store";

const SystemAlertPage = () => {
    const {message, status, updatedAt} = useSystemAlertState();
    const {saveSystemAlert} = useSystemAlertActions();
    const [draftMessage, setDraftMessage] = useState("");
    const [touched, setTouched] = useState(false);
    const { showLoading, hideLoading } = useLoadingActions();
    
    useEffect(() => {
        setDraftMessage(message || "");
        setTouched(false);
    }, [message]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setTouched(false);
        showLoading();
        await saveSystemAlert(draftMessage);
        hideLoading();
    };

    const handleClear = async () => {
        setDraftMessage("");
        setTouched(false);
        showLoading();
        await saveSystemAlert("");
        hideLoading();
    };

    return (
        <PageWrapper>
            <FormPaper onSubmit={handleSubmit}>
                <Stack spacing={8}>
                    <div>
                        <Typography variant="h5" gutterBottom>
                            Downtime Alert
                        </Typography>
                        <Description variant="body2">
                            Use this message to warn users about planned downtime or incidents.
                            Leave the field empty to hide the banner.
                        </Description>
                    </div>

                    <div>
                        <TextField
                            multiline
                            minRows={4}
                            maxRows={10}
                            label="Alert message"
                            value={draftMessage}
                            placeholder="Share planned maintenance or ongoing issues…"
                            onChange={(event) => {
                                setDraftMessage(event.target.value);
                                setTouched(true);
                            }}
                            fullWidth
                            variant="outlined"
                        />

                        {updatedAt && (
                            <Typography variant="caption" color="text.secondary">
                                Last updated:{" "}
                                {Array.isArray(updatedAt)
                                    ? new Date(
                                        updatedAt[0],
                                        (updatedAt[1] || 1) - 1,
                                        updatedAt[2] || 1,
                                        updatedAt[3] || 0,
                                        updatedAt[4] || 0,
                                        updatedAt[5] || 0,
                                        Math.floor((Number(updatedAt[6]) || 0) / 1_000_000)
                                    ).toLocaleString()
                                    : new Date(updatedAt).toLocaleString()}
                            </Typography>
                        )}
                    </div>
                    <Actions direction="row" spacing={2}>
                        <Button
                            variant="outlined"
                            color="inherit"
                            disabled={status === "loading" || (!draftMessage && !message)}
                            onClick={handleClear}
                        >
                            Clear
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={status === "loading" || (!touched && draftMessage === message)}
                        >
                            Save alert
                        </Button>
                    </Actions>
                </Stack>
            </FormPaper>
        </PageWrapper>
    );
};

export default SystemAlertPage;
